'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
var $d_Lpresto_Page = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i(1, "presto.Page", ({
  a2: 1
}));
export { $d_Lpresto_Page as $d_Lpresto_Page };
//# sourceMappingURL=presto.-Page.js.map
